import { getGameListByJumpList } from "@/lobby_common/api/basic_gen.js";
// import { isMobile } from "@/lobby_common/utils/utils.js";
import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import GameMaintai from "@/components/game/game-maintai";
import gameItem from "@/components/game/game-item";
import Collection from "@/components/collection/index.vue";
import { gameImg } from "@/lobby_common/utils/img.js";
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
import { divideAccuracy, isHome } from "@/lobby_common/utils/utils.js";
import { formattedValue } from "@/lobby_common/utils/index.js";
import { getLocalStorage, removeLocalStorage, setLocalStorage } from "@/lobby_common/utils/auth";

export default {
  name: "mode16",
  mixins: [hideGmae],
  components: { Collection, GameMaintai, gameItem },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formattedValue,
      gameImg,
      cur_left: 0,
      max_left: 0,
      timer: null,
      content_index: undefined,
      pcList: [],
      currGameId: undefined,
      target: undefined,
      pageSize: 8,
      page: 1,
      curNum: 4,
      isMore: false, // 是否显示加载更多
      intervalId: null,
      updateInterval: 5000,
      showPoster: true
    };
  },
  computed: {
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
    getImgHeight() {
      const containerWidth =
        document.body.clientWidth > 1340
          ? 1280
          : document.body.clientWidth - 60;
      return containerWidth * 0.15;
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    list() {
      // return [...this.pcList];
      return this.pcList.map((item, i) => {
        return {
          ...item,
          currentValue: this.formattedValue(item.currentValue),
          eid: this.isLatest
            ? `101_21_${this.curindex}_${i}`
            : `101_14_${this.curindex}_${i}`,
        };
      });
    },
    lang() {
      return this.$store.getters.getLang;
    },
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.appConfig?.accuracy
        ? this.$store.getters.getPacketConfig?.appConfig?.accuracy
        : 2;
    },
    accuracy() {
      return this.$store.getters.getCurCoin?.accuracy || this.coin_accuracy;
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    gameShow() {
      return this.packetConfig.gameNameShowPosition !== 4;
    },
    jp_show() {
      return this.packetConfig.gameIconShowJp === "ROW_STATUS_ENABLE";
    },
    isLogin() {
      return this.$store.getters.login;
    },
    storageKey() {
      return `${this.isLogin ? 'login' : 'unlogin'}_game_list`;
    },
    storageJumpId() {
      return this.item.list[0]?.jump?.multipleGame?.sid;
    },
  },
  watch: {},
  async created() {
    this.pageSize = this.IsMobile ? 4 : 8
    this.curNum = this.IsMobile ? 2 : 4

    this.content_index = this.curindex;
    if (this.item.list[0]?.jump?.multipleGame?.sid) {
      // 读取缓存数据
      const storageList = getLocalStorage(this.storageKey);
      if (storageList && this.storageJumpId && storageList[this.storageJumpId] && Array.isArray(storageList[this.storageJumpId])) {
        this.pcList = storageList[this.storageJumpId];
      } else {
        // 清空缓存
        removeLocalStorage(this.storageKey);
      }
    }
    await this.getGamelistFunMenu();
  },
  mounted() {
    // console.log(this.arrContent, 'arrContent')
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async getGamelistFunMenu() {
      let code, data;
      // 游戏展示
      const res =
        (await getGameListByJumpList({
          page: 1,
          pageSize: this.pageSize,
          jumpSid: this.item.list[0].jump.multipleGame?.sid,
          templateType: "home",
        })) || {};
      code = res.code
      data = res.data
      if (code === 0) {
        this.isMore =
          data?.gameList &&
          data?.gameList.length > 0 &&
          data?.gameList.length === this.pageSize;
        // this.jp_show = data.jp_show;
        const games = data?.gameList || [];
        games.forEach((item) => {
          if (item.jpInfo && item.jpInfo.jpValue > 0) {
            item.jpInfo.jpValue = divideAccuracy(
              item.jpInfo.jpValue,
              this.accuracy
            );
            item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
          } else {
            item.jpInfo = {
              jpValue: 0,
              updateTime: 0,
            };
          }
          // if (!item.jpInfo.jpValue) {
          //   item.jpInfo = {
          //     jpValue: 7355645,
          //     updateTime: 1715753477788,
          //   };
          // }
          if (data?.isRecommend) {
            // 开启了千人千面
            item.isRecommend = true;
          }
          item.finalValue = item.jpInfo.jpValue;
          item.initiaValue = item.finalValue * 0.8;
          item.currentValue = this.offsetTimeValue(item);
        });
        this.pcList = games;
        // 缓存数据
        if (isHome()) {
          const storeData = getLocalStorage(this.storageKey) || {};
          storeData[this.storageJumpId] = games;
          setLocalStorage(this.storageKey, storeData);
        }
        // this.pcList = data?.gameList || [];
        if (this.jp_show && this.gameShow) {
          this.startIncrement();
        }
      }
    },
    startIncrement() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.pcList = this.pcList.map((item) => {
          // const minIncrement = item.finalValue * 0.01;
          const maxIncrement = item.finalValue * 0.0005;

          if (item.currentValue < item.finalValue * 0.95) {
            // const randomIncrement = Math.random() * (maxIncrement - minIncrement) + minIncrement;

            item.currentValue += maxIncrement;

            if (item.currentValue > item.finalValue * 0.95) {
              item.currentValue = item.finalValue;
            }
          } else {
            item.currentValue = item.initiaValue;
          }
          return item;
        });
      }, this.updateInterval);
    },
    // 计算差值
    offsetTimeValue(item) {
      const jpInfo = item.jpInfo;
      if (!jpInfo.jpValue || jpInfo.jpValue < 1 || jpInfo.updateTime < 1) {
        return jpInfo.jpValue;
      }
      // 计算时间差值 (当前时间-数据更新时间) / 1000 * 每秒更新值
      const offset =
        ((Date.now() - jpInfo.updateTime) / 5000) * (jpInfo.jpValue * 0.0005);
      let currentValue = jpInfo.jpValue * 0.8 + offset;

      if (currentValue > jpInfo.jpValue * 0.95) {
        currentValue = jpInfo.jpValue * 0.8;
      }

      return currentValue;
    },
    changePosition(dir = "left") {
      const that = this;
      const dom = document.querySelector(`.content_${this.curindex}`);
      if (dom) {
        const target =
          dir === "left" ? that.cur_left - 100 : that.cur_left + 100;
        // if(that.cur_left === 0) dom.style.left = 0
        // else dom.style.left = `-${that.cur_left}00%`
        this.target = target;
        this.animateDom(target, dom, dir);
      }
    },
    animateDom(target, dom, dir) {
      const that = this;
      if (that.timer) {
        return false;
      }
      // let timer = that.timer;
      that.timer = setInterval(function () {
        const speed = dir === "left" ? -5 : 5; // 判断是向左走（负）还是向右走（正）
        // console.log(dir, that.cur_left, target)
        if (that.cur_left === target) {
          clearInterval(that.timer);
          that.timer = null;
        } else {
          that.cur_left = that.cur_left + speed;
          if (that.cur_left === 0) dom.style.left = 0;
          else dom.style.left = `-${that.cur_left}%`;
        }
      }, 10);
    },
    judgeMode(opt) {
      console.log("judgeMode", opt);
      if (this.maintaiGame[opt.gameGroupSid]) {
        return false;
      }
      if (opt.canTestPlay === "STATUS_BOOL_FALSE") {
        this.$store.commit("setRecordGame", opt);

        payGameFun(opt);
      } else {
        if (this.IsMobile) {
          // 游戏详情页面
          this.$isPopShow({
            show: true,
            views: "hgame",
            data: {
              ...opt,
            },
          });
        }
      }
    },
    // PC弹出真玩、试玩收藏
    pcPayGame(opt) {
      if (this.maintaiGame[opt.gameGroupSid]) {
        return false;
      }
      if (this.cur_gid === opt.gameGroupSid) {
        return false;
      }
      if (this.IsMobile) return;
      this.currGameId = opt.gameGroupSid;
      return;
    },
    pcLeaveGame() {
      this.currGameId = null;
      return;
    },
    payGame(opt, canTestPlay, isRoom = false) {
      this.$store.commit("setRecordGame", opt);
      const replace = false;
      payGameFun(opt, canTestPlay, replace, isRoom);
    },
    getGameIcon(keys) {
      const key = keys || null;
      if (key) return require(`@/assets/new/${key}.png`);
    },
    handleClick(item) {
      this.$eventPost("click", {
        eid: `101_0_${this.curindex}_132`,
        time: Date.now(),
      });
      // 游戏展示
      item["bindType"] = 2;
      console.log(item, "Cur_paramsCur_paramsCur_params");
      localStorage.setItem("Cur_params", JSON.stringify(item));
      this.$router.push({ name: "homeSearch" });
    },
  },
  activated() {
    setTimeout(() => {
      const video = document.getElementById('background-video')
      if (video && video.paused) {
        video.play().catch(err => {
          console.warn('路由切换后播放失败:', err)
        })
      }
    }, 100)
  }
};
